import React, { useState, useEffect } from 'react';
import Swal from 'sweetalert2';
import { emailRegex, FormState } from '@opu/utils';
import AxiosInstance from '../../../helpers/AxiosInstance';
import { useTranslation } from 'react-i18next';

const useForm = () => {
  const { t, i18n } = useTranslation();

  const createContact = (e) => {
    e.preventDefault();
    AxiosInstance.post('/student/contact', {
      topic: formState.inputValues.topic,
      email: formState.inputValues.email,
      message: formState.inputValues.message,
    })
      .then((res) => {
        Swal.fire(t('contact.SUCCESS_CREATE_CONTACT'), '', 'success');
        resetFormState();
      })
      .catch((error) => {
        if (error.status === 400) {
          handleErrorsServer(error.data.message);
        }
        Swal.fire(t('contact.ERROR_CREATE_CONTACT'), '', 'error');
      });
  };

  const inputValues = {
    topic: { value: '', validate: { required: true } },
    email: { value: '', validate: { required: true, pattern: emailRegex } },
    message: { value: '', validate: { required: true, min: 10 } },
  };

  const { formState, submitHandler, resetFormState, loading, field, handleErrorsServer } = FormState(inputValues, createContact);

  return {
    submitHandler,
    resetFormState,
    loading,
    field,
  };
};

export default useForm;
